import React, {memo} from 'react';

import {SearchDestinationSummaryInputField} from '../SearchDestinationSummaryInputField/SearchDestinationSummaryInputField';
import {SearchSubmitSummaryButtonField} from '../SearchSubmitSummaryButtonField/SearchSubmitSummaryButtonField';
import {SearchDestinationSummaryDetails} from '../SearchDestinationSummaryDetails/SearchDestinationSummaryDetails';

import {useComponent} from './hooks/useComponent';

import '../SearchSummaryField/SearchSummaryField.less';
import '../SearchSummaryInputField/SearchSummaryInputField.less';
import '../SearchSummaryButtonField/SearchSummaryButtonField.less';
import './SearchSummaryFields.less';
import '../SearchDestinationSummaryDetails/SearchDestinationSummaryDetails.less';

const SearchSummaryFields = memo(function SearchSummaryFields() {
    const {
        className,
        isCollapsedPDPSearchFormCTAv2Experiment
    } = useComponent();

    return (
        <div className={className}>
            {isCollapsedPDPSearchFormCTAv2Experiment && <SearchDestinationSummaryDetails />}
            {!isCollapsedPDPSearchFormCTAv2Experiment && (
                <>
                    <SearchDestinationSummaryInputField />
                    <SearchSubmitSummaryButtonField/>
                </>
            )}
        </div>
    );
});

SearchSummaryFields.whyDidYouRender = true;

export {SearchSummaryFields};
